import { Routes, IS_DEV_ENV, getBridgeEnvironment, getInterBridgeInstance } from 'common/constants'

import { WbSessionActions, WbEnvironments, interWbNavigate } from '@interco/inter-webview-bridge'

import { router } from '../routes/index'

let hasGoBackListener = false

interface NavigationState {
  previousRoute?: Routes
}

const isNavigationState = (state: unknown): state is NavigationState =>
  typeof state === 'object' && state !== null && 'previousRoute' in state

const isHomeFromRoot = () => {
  const { pathname, state } = router.state.location
  const previousRoute = isNavigationState(state) ? state.previousRoute : undefined

  return pathname === Routes.HOME && previousRoute === Routes.ROOT
}

const registerGoBackListener = () => {
  const interBridge = getInterBridgeInstance()

  if (!interBridge || hasGoBackListener) return
  if (getBridgeEnvironment() !== WbEnvironments.ANDROID) return
  if (typeof interBridge.addWebviewEventListener !== 'function') return

  interBridge.addWebviewEventListener(WbSessionActions.GO_BACK, () => {
    try {
      if (
        window.location.pathname === Routes.ROOT ||
        window.location.pathname === Routes.ERROR ||
        window.location.pathname === Routes.ENTITY ||
        isHomeFromRoot()
      ) {
        interWbNavigate.requestGoBack()
        return
      }

      router.navigate(-1)
    } catch (error: unknown) {
      if (IS_DEV_ENV) {
        global.console.debug('Failed to handle go back bridge event', error)
      }
    }
  })

  hasGoBackListener = true
}

registerGoBackListener()
